import React, { useState, useMemo } from "react";
import {
    Dialog,
    DialogTitle,
    DialogContent,
    Button,
    TextField,
    Box,
    Typography,
    Grid,
    MenuItem,
} from "@mui/material";
import { Formik } from "formik";
import * as Yup from "yup";
import { useDispatch } from "store";
import { openSnackbar, closeSnackbar } from "store/slices/snackbar";
import Select from "react-select";
import { useGetPortfolioSummaryQuery } from "store/slices/apis/portfolioSummarySlice";
import { useGetAllProjectsQuery } from "store/slices/apis/projectApiSlice";
import { useParams } from "react-router-dom";
import { useGetMasterDataQuery } from "store/slices/apis/masterConfigation";
import { useCreateInsuranceMutation } from "store/slices/apis/insuranceTrackerSlice";



const labelTextStyle = {
    fontWeight: 500,
    fontSize: "16px",
    lineHeight: "100%",
    color: "#5F5F5F",
    fontFamily: "Outfit, sans-serif",
    mb: 1,
    mt: 1,
};




const AddInsurance = (props) => {
    const { open, handleClose, refetchList } = props;
    const dispatch = useDispatch();
    const { projectId: routeProjectId } = useParams();
    const module = "Insurance"

    const { data: policyData } = useGetMasterDataQuery({ module: module, category: 'policyStatus', ProjectId: routeProjectId });
    const { data: insuranceTypeData } = useGetMasterDataQuery({ module: module, category: 'insuranceType', ProjectId: routeProjectId });
    const { data: statusData } = useGetMasterDataQuery({ module: module, category: 'Status', ProjectId: routeProjectId });

    const insuranceTypeOptions =
        insuranceTypeData?.data
            ?.map((item) => ({
                label: item?.value,
                value: item?.value
            }))
            ?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const projectStatusOptions =
        statusData?.data
            ?.map((item) => ({
                label: item?.value,
                value: item?.value
            }))
            ?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const policyStatusOptions =
        policyData?.data
            ?.map((item) => ({
                label: item?.value,
                value: item?.value
            }))
            ?.sort((a, b) => a.label.localeCompare(b.label)) || [];

    const [projectType, setProjectType] = useState(localStorage.getItem("projectType") || "all")

    const { data, error, isLoading, isFetching: isProjectFething, refetch } = useGetAllProjectsQuery(projectType);
    const { data: portfolioData, isFetching: portfolioLoader, isError: portfolioError } = useGetPortfolioSummaryQuery();

    const projectData = data?.data || [];
    const filteredProjectData = projectData.filter((data) => data.active == true);

    const projectOptions = (filteredProjectData || []).map(p => ({
        value: p.projectId,
        label: p.projectName,
        projectType: p.projectType,
    }));

    const portfolioOptions = (portfolioData?.data || []).map(p => ({
        value: p.portfolioName,
        label: p.portfolioName,
        projectType: p.portFolioType,
    }));

    const portfolioSelectOptions = useMemo(
        () => [
            // { projectType: "all", label: "All Portfolio" },
            ...portfolioOptions,
        ],
        [portfolioOptions]
    );

    const handlePortfolioChange = (option, setFieldValue) => {
        let projectType = option?.projectType || "all";
        setProjectType(projectType);
        localStorage.setItem("projectType", projectType)
        setFieldValue("product", option?.value || "");
    };

    const [createInsurance] = useCreateInsuranceMutation();


    const initialValues = {
        projectStatus: "",
        insuranceType: "",
        policyStatus: "",
        insuranceProvider: "",
        coverageStartDate: "",
        coverageEndDate: "",
        underwritingCost: "",
        actualCost: "",
        policyLink: "",
        product: "",
        project: "",
        projectId: ""
    };

    const validationSchema = Yup.object().shape({
        projectStatus: Yup.string().required("Project Status is required"),
        insuranceType: Yup.string().required("Insurance Type is required"),
        // policyStatus: Yup.string().required("Policy Status is required"),
        product: Yup.string().required("Product is required"),
        project: Yup.string().required("Project is required"),
        // insuranceProvider: Yup.string().required("Insurance Provider is required"),
        // coverageStartDate: Yup.date()
        //     .required("Coverage Start Date is required")
        //     .typeError("Invalid date"),
        // coverageEndDate: Yup.date()
        //     .required("Coverage End Date is required")
        //     .typeError("Invalid date")
        //     .min(Yup.ref("coverageStartDate"), "End date cannot be before start date"),
        underwritingCost: Yup.number()
            .typeError("Must be a number")
            .min(0, "Cannot be negative"),

        actualCost: Yup.number()
            .typeError("Must be a number")
            .min(0, "Cannot be negative"),

        // policyLink: Yup.string().url("Invalid URL").required("Policy Link is required"),
    });
    const stringToDecimal = (value) => {
        if (value === "" || value === null || value === undefined) return null;

        const num = Number(value);
        if (isNaN(num)) return null;

        return Number(num.toFixed(2));
    };

    const convertToUTC = (date) => {
        if (!date) return null;
        return new Date(date).toISOString();
    };

    const emptyGUID = "00000000-0000-0000-0000-000000000000";

    const handleSubmit = async (values, { setSubmitting, resetForm }) => {
        const reqBody = {
            projectStatus: values.projectStatus,
            insuranceType: values.insuranceType,
            policyStatus: values.policyStatus,
            insuranceProvider: values.insuranceProvider,
            coverageStartDate: convertToUTC(values.coverageStartDate),
            coverageEndDate: convertToUTC(values.coverageEndDate),
            underwritingCost: stringToDecimal(values.underwritingCost),
            actualCost: stringToDecimal(values.actualCost),
            policyLink: values?.policyLink || "",
            product: values?.product || "",
            project: values?.project || "",
            projectId: values?.projectId || "",
        };

        try {
            const response = await createInsurance({ body: reqBody }).unwrap();


            if (response) {
                openNotification(response.message, "success");
                if (refetchList) refetchList();
                handleClose();
                resetForm();
            } else {
                openNotification(response?.message || "Something went wrong", "error");
            }
        } catch (error) {
            console.error("Submit Error:", error);
            let errorMessage = "Something went wrong";
            if (error?.data?.message) errorMessage = error.data.message;
            else if (error?.error) errorMessage = error.error;
            else if (error?.message) errorMessage = error.message;
            openNotification(errorMessage, "error");
        } finally {
            setSubmitting(false);
        }
    };

    const openNotification = (msg, type = "error", duration = 3000) => {
        dispatch(
            openSnackbar({
                open: true,
                message: msg,
                variant: "alert",
                alert: { color: type },
                close: false,
            })
        );
        setTimeout(() => dispatch(closeSnackbar()), duration);
    };

    return (
        <Dialog
            open={open}
            fullWidth
            maxWidth="md"
            PaperProps={{
                sx: {
                    borderTopLeftRadius: "5px",
                    borderTopRightRadius: "5px",
                    backgroundColor: "#FFFFFF",
                    width: "100%",
                    overflowX: "hidden",
                },
            }}
            disableEscapeKeyDown
            onClose={(event, reason) => {
                if (reason !== "backdropClick") {
                    handleClose();
                }
            }}
        >
            <DialogTitle
                sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "space-between",
                    borderBottom: "1px solid #ddd",
                    backgroundColor: "#ECECEC",
                    pb: 2,
                    pt: 3,
                    width: "100%",
                }}
            >
                <Box>
                    <Typography
                        sx={{
                            fontWeight: 600,
                            fontSize: "27px",
                            lineHeight: "100%",
                            color: "#140F36",
                            fontFamily: "Outfit, sans-serif",
                        }}
                    >
                        Add Insurance Record
                    </Typography>
                </Box>
            </DialogTitle>
            <DialogContent dividers>
                <Formik
                    initialValues={initialValues}
                    validationSchema={validationSchema}
                    onSubmit={handleSubmit}
                >
                    {({
                        values,
                        errors,
                        touched,
                        handleChange,
                        handleBlur,
                        handleSubmit,
                        isSubmitting,
                        setFieldTouched,
                        setFieldValue,
                        submitCount
                    }) => (
                        <form onSubmit={handleSubmit}>
                            <Grid container spacing={2}>
                                {routeProjectId == undefined &&
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>
                                            Product
                                        </Typography>

                                        <Select
                                            name="product"
                                            options={portfolioSelectOptions}
                                            value={
                                                portfolioSelectOptions.find(
                                                    (opt) => opt.value === values.product
                                                ) || null
                                            }
                                            onChange={(option) => handlePortfolioChange(option, setFieldValue)}
                                            onBlur={() => setFieldTouched("product", true)}
                                            placeholder="Select Portfolio"
                                        />

                                        {(touched.product || submitCount > 0) && errors.product && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.product}
                                            </Typography>
                                        )}
                                    </Grid>
                                }

                                {routeProjectId == undefined &&
                                    <Grid size={{ xs: 12, md: 6 }}>
                                        <Typography sx={labelTextStyle}>
                                            Project
                                        </Typography>

                                        <Select
                                            name="project"
                                            options={[{ value: emptyGUID, label: "All Projects" }, ...projectOptions]}
                                            value={
                                                [{ value: emptyGUID, label: "All Projects" }, ...projectOptions]
                                                    .find(opt => opt.value === values.projectId) || null
                                            }
                                            onChange={(option) => {
                                                setFieldValue("projectId", option?.value);
                                                setFieldValue("project", option?.label);
                                            }}
                                            onBlur={() => setFieldTouched("project", true)}
                                            placeholder="Select Project"
                                        />

                                        {(touched.project || submitCount > 0) && errors.project && (
                                            <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                                {errors.project}
                                            </Typography>
                                        )}
                                    </Grid>
                                }
                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>
                                        Project Status
                                    </Typography>
                                    <Select
                                        name="projectStatus"
                                        options={projectStatusOptions}
                                        value={projectStatusOptions.find(opt => opt.value === values.projectStatus) || null}
                                        onChange={(option) => setFieldValue("projectStatus", option.value)}
                                        onBlur={() => setFieldTouched("projectStatus", true)}
                                        placeholder="Select Project Status"
                                    />
                                    {touched.projectStatus && errors.projectStatus && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.projectStatus}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>
                                        Insurance Type
                                    </Typography>
                                    <Select
                                        name="insuranceType"
                                        options={insuranceTypeOptions}
                                        value={insuranceTypeOptions.find(opt => opt.value === values.insuranceType) || null}
                                        onChange={(option) => setFieldValue("insuranceType", option.value)}
                                        onBlur={() => setFieldTouched("insuranceType", true)}
                                        placeholder="Select Insurance Type"
                                    />
                                    {touched.insuranceType && errors.insuranceType && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.insuranceType}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>
                                        Policy Status
                                    </Typography>
                                    <Select
                                        name="policyStatus"
                                        options={policyStatusOptions}
                                        value={policyStatusOptions.find(opt => opt.value === values.policyStatus) || null}
                                        onChange={(option) => setFieldValue("policyStatus", option.value)}
                                        onBlur={() => setFieldTouched("policyStatus", true)}
                                        placeholder="Select Policy Status"
                                    />
                                    {touched.policyStatus && errors.policyStatus && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.policyStatus}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>
                                        Insurance Provider
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="insuranceProvider"
                                        value={values.insuranceProvider}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter provider name"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#5F5F5F",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.insuranceProvider && errors.insuranceProvider && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.insuranceProvider}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>
                                        Coverage Start Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        name="coverageStartDate"
                                        value={values.coverageStartDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.coverageStartDate && errors.coverageStartDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.coverageStartDate}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>
                                        Coverage End Date
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        type="date"
                                        name="coverageEndDate"
                                        value={values.coverageEndDate}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                },
                                            },
                                        }}
                                    />
                                    {touched.coverageEndDate && errors.coverageEndDate && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.coverageEndDate}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>
                                        Underwriting Cost (USD)
                                    </Typography>
                                    <TextField
                                        fullWidth

                                        name="underwritingCost"
                                        value={values.underwritingCost}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter cost"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#5F5F5F",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.underwritingCost && errors.underwritingCost && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.underwritingCost}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 6 }}>
                                    <Typography sx={labelTextStyle}>
                                        Actual Cost (USD)
                                    </Typography>
                                    <TextField
                                        fullWidth

                                        name="actualCost"
                                        value={values.actualCost}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="Enter actual cost"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#5F5F5F",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.actualCost && errors.actualCost && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.actualCost}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={{ xs: 12, md: 12 }}>
                                    <Typography sx={labelTextStyle}>
                                        Policy Link
                                    </Typography>
                                    <TextField
                                        fullWidth
                                        name="policyLink"
                                        value={values.policyLink}
                                        onChange={handleChange}
                                        onBlur={handleBlur}
                                        placeholder="https://example.com/policy"
                                        InputProps={{
                                            sx: {
                                                height: "40px",
                                                borderRadius: "8px",
                                                backgroundColor: "#fff",
                                                "& input::placeholder": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#5F5F5F",
                                                    fontFamily: "Outfit, sans-serif",
                                                    opacity: 1,
                                                },
                                                "& input": {
                                                    fontWeight: 400,
                                                    fontSize: "16px",
                                                    lineHeight: "100%",
                                                    letterSpacing: "0.16px",
                                                    color: "#0A0A0C",
                                                    fontFamily: "Outfit, sans-serif",
                                                    "&:-webkit-autofill": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:hover": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                    "&:-webkit-autofill:focus": {
                                                        WebkitBoxShadow: "0 0 0 1000px white inset",
                                                        WebkitTextFillColor: "#0A0A0C",
                                                    },
                                                },
                                            },
                                        }}
                                    />
                                    {touched.policyLink && errors.policyLink && (
                                        <Typography sx={{ color: "#d32f2f", fontSize: "12px", mt: 0.5 }}>
                                            {errors.policyLink}
                                        </Typography>
                                    )}
                                </Grid>

                                <Grid size={12}>
                                    <Box
                                        sx={{
                                            display: "flex",
                                            justifyContent: "flex-end",
                                            alignItems: "center",
                                            mt: 2,
                                        }}
                                    >
                                        <Button
                                            onClick={handleClose}
                                            sx={{
                                                textTransform: "none",
                                                color: "#F15744",
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                borderRadius: "25px",
                                                fontWeight: 500,
                                                px: "20px",
                                                py: "15px",
                                            }}
                                        >
                                            Cancel
                                        </Button>
                                        <Button
                                            type="submit"
                                            variant="contained"
                                            disabled={isSubmitting}
                                            sx={{
                                                backgroundColor: "#00344C",
                                                borderRadius: "25px",
                                                textTransform: "none",
                                                fontWeight: 500,
                                                fontSize: "14px",
                                                lineHeight: "100%",
                                                fontFamily: "Outfit, sans-serif",
                                                color: "#FFFFFF",
                                                px: "20px",
                                                py: "15px",
                                                '&:disabled': {
                                                    backgroundColor: '#cccccc',
                                                }
                                            }}
                                        >
                                            {isSubmitting ? "Saving..." : "Save"}
                                        </Button>
                                    </Box>
                                </Grid>
                            </Grid>
                        </form>
                    )}
                </Formik>
            </DialogContent>
        </Dialog>
    );
};

export default AddInsurance;